import { ModuleConfig } from '@/core/module';
import { flowSimulatorRoutes } from './routes';

export const FlowSimulatorModule: ModuleConfig = {
    name: 'flow-simulator',
    displayName: 'Flow Simulator',
    description: 'Developer tool for previewing workflow nodes with mock data',
    routes: flowSimulatorRoutes,
    initialize: () => {
        console.log('Flow Simulator module initialized');
    },
};
